import angular from 'angular';
import {hasFeature} from 'acng/core/service/env';
import {Tile} from 'acng/core/widgets/basic-tile.js';
import {NotFoundWithBlocked} from '../model/stock';

angular.module('stock')
  .factory('StockTile', ['$injector',
    /**
     * @param {angular.auto.IInjectorService} $injector
     */
    ($injector) => {
    const MovieTile = hasFeature('moviePool') ? $injector.get('MovieTile') : false;
    const PictureThumbnail = hasFeature('picturePool') ? $injector.get('PictureThumbnail') : false;
    //const PictureSetTile = hasFeature('picturePool') ? $injector.get('PictureSetTile') : false;
    const PayttachmentTile = hasFeature('messenger') ? $injector.get('PayttachmentTile') : false;

    class StockTile extends Tile
    {
      load(scope, stockitem) {
        scope.stockitem = stockitem;
        switch (stockitem.type) {
          case 'Movie':
            return MovieTile.prototype.load.call(this, scope, stockitem.article_id)
              .catch((reason) => {
                if (reason instanceof NotFoundWithBlocked) {
                  this.reportMissingItem(stockitem);
                  throw reason;
                }
              });
          case 'Picture':
            return PictureThumbnail.prototype.load.call(this, scope, stockitem.article_id)
              .catch((reason) => {
                if (reason instanceof NotFoundWithBlocked) {
                  this.reportMissingItem(stockitem);
                  throw reason;
                }
            });
          case 'Payttachment':
            return PayttachmentTile.prototype.load.call(this, scope, stockitem.article_id);
          default:{
            throw { msg: 'invalid stockitem', stockitem };
          }
        }
      }

      /**
         * @param {{ article_id: any; type: any; }} stockItem
         */
      reportMissingItem(stockItem) {
        const formData = new FormData();
        formData.append('article_id', stockItem.article_id);
        formData.append('type', stockItem.type);
        navigator.sendBeacon(`api/user/stock/report-missing-item`, formData);
      }

      hookname() {
        return 'media';
      }
    }
    return StockTile;
  }]);
